<template>
  <LegalDocPage :template="privacyTemplate" document="privacy" />
</template>

<script setup lang="ts">
import LegalDocPage from '@/features/legal/components/legal-doc-page/legal-doc-page.vue'
import privacyTemplate from '@/features/legal/templates/privacy.md?raw'
</script>
